export const SET_KANBAN_GROUP_BY_ATTRIBUTE_KEY =
  'SET_KANBAN_GROUP_BY_ATTRIBUTE_KEY';
export const SET_KANBAN_UI_FLAG = 'SET_KANBAN_UI_FLAG';
export const SET_KANBAN_COLUMN_FETCHING = 'SET_KANBAN_COLUMN_FETCHING';
export const SET_KANBAN_COLUMN_CONTACTS = 'SET_KANBAN_COLUMN_CONTACTS';
export const MOVE_KANBAN_CONTACT = 'MOVE_KANBAN_CONTACT';
export const RESET_KANBAN_COLUMNS = 'RESET_KANBAN_COLUMNS';

export const buildEmptyColumn = () => ({
  contactIds: [],
  contactsById: {},
  meta: { currentPage: 0, count: 0, hasMore: false },
  isFetching: false,
  isFetchingMore: false,
});

export const mutations = {
  [SET_KANBAN_GROUP_BY_ATTRIBUTE_KEY]($state, attributeKey) {
    $state.groupByAttributeKey = attributeKey;
  },

  [SET_KANBAN_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [SET_KANBAN_COLUMN_FETCHING](
    $state,
    { columnValue, isFetching, isFetchingMore }
  ) {
    const column = $state.columns[columnValue] || buildEmptyColumn();
    $state.columns = {
      ...$state.columns,
      [columnValue]: {
        ...column,
        isFetching: isFetching ?? column.isFetching,
        isFetchingMore: isFetchingMore ?? column.isFetchingMore,
      },
    };
  },

  [SET_KANBAN_COLUMN_CONTACTS](
    $state,
    { columnValue, contacts, meta, append }
  ) {
    const column = $state.columns[columnValue] || buildEmptyColumn();
    const contactsById = append ? { ...column.contactsById } : {};
    const contactIds = append ? [...column.contactIds] : [];

    contacts.forEach(contact => {
      contactsById[contact.id] = contact;
      if (!contactIds.includes(contact.id)) {
        contactIds.push(contact.id);
      }
    });

    $state.columns = {
      ...$state.columns,
      [columnValue]: {
        ...column,
        contactIds,
        contactsById,
        meta,
        isFetching: false,
        isFetchingMore: false,
      },
    };
  },

  [MOVE_KANBAN_CONTACT]($state, { contactId, fromColumnValue, toColumnValue }) {
    const fromColumn = $state.columns[fromColumnValue];
    if (!fromColumn) return;

    const contact = fromColumn.contactsById[contactId];
    if (!contact) return;

    const toColumn = $state.columns[toColumnValue] || buildEmptyColumn();
    const remainingContactsById = { ...fromColumn.contactsById };
    delete remainingContactsById[contactId];

    $state.columns = {
      ...$state.columns,
      [fromColumnValue]: {
        ...fromColumn,
        contactIds: fromColumn.contactIds.filter(id => id !== contactId),
        contactsById: remainingContactsById,
        meta: {
          ...fromColumn.meta,
          count: Math.max(0, fromColumn.meta.count - 1),
        },
      },
      [toColumnValue]: {
        ...toColumn,
        contactIds: [contactId, ...toColumn.contactIds],
        contactsById: { ...toColumn.contactsById, [contactId]: contact },
        meta: { ...toColumn.meta, count: toColumn.meta.count + 1 },
      },
    };
  },

  [RESET_KANBAN_COLUMNS]($state) {
    $state.columns = {};
  },
};
